















































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import { TicketResourceType, TicketStatus } from '@/modules/ticket/models/ticket-resource.model'
import TicketAnswerList from '@/modules/ticket-answer/components/shared/TicketAnswerList.vue'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import TicketTabularHeader from '@/modules/ticket/components/shared/TicketTabularHeader.vue'
import TicketNewAnswerForm from '@/modules/ticket-answer/components/shared/TicketNewAnswerForm.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { OpenTicketUseCase } from '@/modules/ticket/use-cases/shared/open-ticket.use-case'
import { CloseTicketUseCase } from '@/modules/ticket/use-cases/shared/close-ticket.use-case'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'تیکت'
  },
  metaInfo: {
    title: 'تیکت'
  },
  components: {
    AlertNotification,
    BaseButton,
    TicketNewAnswerForm,
    TicketTabularHeader,
    TicketAnswerList,
    BaseCard
  }
})
export default class PanelTicketShowPage extends Vue {
  constructor(
    private readonly openTicketUseCase: OpenTicketUseCase,
    private readonly closeTicketUseCase: CloseTicketUseCase
  ) {
    super()
  }

  @Prop() ticket: TicketResourceType

  get isTicketActive() {
    return this.ticket.data.status !== TicketStatus.CLOSED
  }

  get isLoading() {
    return this.openTicketUseCase.isLoading || this.closeTicketUseCase.isLoading
  }

  get buttonProps() {
    const sharedProps = { loading: this.isLoading }
    const activeButtonProps = {
      ...sharedProps,
      label: 'باز کردن تیکت',
      icon: 'ion open-outline',
      color: 'tes-green'
    }
    const inactiveButtonProps = {
      ...sharedProps,
      label: 'بستن تیکت',
      icon: 'ion close-outline',
      color: 'tes-blue-dark',
      outline: true
    }

    return this.isTicketActive
      ? inactiveButtonProps
      : activeButtonProps
  }

  ticketToggle() {
    if (this.isTicketActive) {
      this.closeTicketUseCase.execute(this.ticket.data.id)
    } else {
      this.openTicketUseCase.execute(this.ticket.data.id)
    }
  }

  get showNewAnswer() {
    return this.ticket.data.status !== TicketStatus.CLOSED
  }
}
